import ClinicContainer from './containers/ClinicContainer.jsx'

// Sync route definition
export default {
  path      : '/clinic-tools',
  component : ClinicContainer
}



// WEBPACK FOOTER //
// ./src/routes/Clinic/index.jsx